export default{sources:{avif:"__VITE_ASSET__BbHAd$4E__ 400w",webp:"__VITE_ASSET__CCsCpo5A__ 400w"},img:{src:"__VITE_ASSET__DdODCgiV__",w:400,h:533}};